<template>
    <div class="map-box" v-if="flag">
        <gmap-map
            :center="centers"
            :zoom="11"
            map-type-id="terrain"
            style="width: 100%; height: 100vh"
        >
            <gmap-marker
                @dragend="updateMaker"
                :key="index"
                v-for="(m, index) in markers"
                :position="m.position"
                :clickable="true"
                :draggable="true"
                @click="centers=m.position"
            ></gmap-marker>
        </gmap-map>

        <div class="btn" @click="backPage">返回</div>
    </div>

</template>
<script>
    import Vue from 'vue'
    import * as VueGoogleMaps from 'vue2-google-maps'
    Vue.use(VueGoogleMaps, {
        load: {
            key: 'AIzaSyCQlG0OoU8dt9Wl5RGFX67O8Iav9CSaC8I',
            libraries: '3.26',
        },
    })

    export default {
        name: 'goods_map',
        data() {
            return {
                flag: false,
                centers: {
                    lat: 39.90419989999999, lng: 116.4073963
                },
                markers: [{
                    position: {lat: 39.90419989999999, lng: 116.4073963}
                }],
                place: null,
            }
        },
        beforeMount() { //模型加载前
            let _this = this;
        },
        created() { //视图加载前执行
            let _this = this;
        },
        mounted() { //视图加载完成执行
            let _this = this;
            _this.centers.lat = _this.$route.query.lat ? parseInt(_this.$route.query.lat) : 39.916527;
            _this.centers.lng = _this.$route.query.long ? parseInt(_this.$route.query.long) : 116.397128;
            _this.getCoordinate();
        },
        methods: {

            // 返回上一页面
            backPage(){
                this.$router.go(-1);
            },

            // 赋值重新点坐标
            getCoordinate() {
                let _this = this;
                _this.markers[0].position.lat = _this.centers.lat;
                _this.markers[0].position.lng = _this.centers.lng;
                _this.flag = true;
            },

            // 更新坐标点
            updateMaker: function (event) {
                console.log('updateMaker, ', event.latLng.lat());
                this.markers[0].position = {
                    lat: event.latLng.lat(),
                    lng: event.latLng.lng(),
                }
            },
        },
        destroyed() {

        }
    }
</script>
<style lang="scss">
    @import "map.scss";
</style>
